<template>
  <div class="d-flex flex-column pt-2">
    <v-card
      flat
      color="#f2f9ff"
      class="d-flex flex-column flex-sm-row py-2 my-2 mx-auto d-print-none grayBorder pricesToolbar"
    >
      <v-text-field
        v-model="feesDiscounts.insurance"
        label="Insurance Contribution"
        prefix="$"
        class="pa-2 ma-1"
        :class="topInputClass"
        dense
        @blur="feesDiscounts.insurance = getNumber(feesDiscounts.insurance)"
        hide-details="auto"
      ></v-text-field>

      <v-text-field
        v-model="feesDiscounts.yearDiscount"
        label="Year purchase discount"
        prefix="$"
        class="pa-2 ma-1"
        :class="topInputClass"
        dense
        @blur="
          feesDiscounts.yearDiscount = getNumber(feesDiscounts.yearDiscount)
        "
        hide-details="auto"
      ></v-text-field>

      <v-text-field
        label="Shipping: 1 year Supply"
        v-model="feesDiscounts.shippingYear"
        prefix="$"
        class="pa-2 ma-1"
        :class="topInputClass"
        dense
        @blur="
          feesDiscounts.shippingYear = getNumber(feesDiscounts.shippingYear)
        "
        hide-details="auto"
      ></v-text-field>
      <v-text-field
        label="Shipping: Other Supply"
        v-model="feesDiscounts.shippingPartial"
        prefix="$"
        class="pa-2 ma-1"
        :class="topInputClass"
        dense
        @blur="
          feesDiscounts.shippingPartial = getNumber(
            feesDiscounts.shippingPartial
          )
        "
        hide-details="auto"
      ></v-text-field>

      <div class="min200 text-center">
        <v-checkbox
          v-model="feesDiscounts.willShip"
          dense
          label="Shipping needed"
          hide-details="auto"
        >
        </v-checkbox>
      </div>

      <v-spacer></v-spacer>

      <div class="d-flex flex-row align-center my-1" justify-space-between>
        <v-btn
          depressed
          small
          @click="resetAllTabs"
          :disabled="!formDirty"
          color="#FFF"
          class="mx-1"
        >
          <v-icon color="red"> mdi-close </v-icon> Reset All
        </v-btn>

        <v-btn
          depressed
          small
          @click="addTab"
          :disabled="noMoreTabs"
          color="#FFF"
          class="mx-1"
        >
          <v-icon color="green"> mdi-plus </v-icon> Tab
        </v-btn>

        <price-settings-home
          class="mx-1"
          @defaultSettings="settingsFromDefault($event)"
        ></price-settings-home>

        <v-btn icon @click="printWindow" class="mx-1">
          <v-icon>mdi-printer</v-icon>
        </v-btn>
      </div>
    </v-card>

    <v-tabs
      centered
      dense
      v-model="selectedTab"
      show-arrows
      v-show="tabs.length > 1"
      class="d-print-none"
    >
      <v-tab v-for="(t, index) in tabs" :key="t.tCount" :href="'#tab-' + index">
        <!-- <img
          v-if="t.image"
          :src="CL_IMAGE_DIR + t.image" 
          class="imageIcon mr-2 d-none d-md-inline-block"
        /> -->
        <product-image
          v-if="t.image"
          :fileString="t.image"
          type="scl"
          :maxWidth="35"
          :maxHeight="50"
          :altText="t.name + ' product image'"
          class="mr-2 d-none d-md-inline-block"
          position="center center"
        ></product-image>

        {{ t.title }}

        <v-btn icon @click="removeTab(index)" class="ml-2"
          ><v-icon x-small>mdi-close</v-icon></v-btn
        >
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab" class="pt-2 grayBkgd">
      <v-tab-item
        transition="fade-transition"
        reverse-transition="fade-transition"
        v-for="(t, index) in tabs"
        :key="t.tCount"
        :value="'tab-' + index"
      >
        <price-calc-tab
          :feesDiscounts="feesDiscounts"
          :lensIDs="index == 0 ? lensIDs : null"
          :index="index"
          @brandData="brandDataChange(index, $event)"
        ></price-calc-tab>
      </v-tab-item>
    </v-tabs-items>
    <div class="d-none d-print-block my-4">
      {{ feesDiscounts.appendTextToPrinted }}
    </div>
  </div>
</template>

<script>
import PriceCalcTab from "./PriceCalcTab.vue";
import PriceSettingsHome from "./PriceSettingsHome.vue";
// import { lensImageForFile } from "./utilities/lensHelpers";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";
import ProductImage from "@/components/clStuff/ProductImage";
// import HardLinksMixin from "@/assets/js/HardLinksMixin"
// import LensSearch from "../components/LensSearch";
//import FamilyLensSelector from "../components/FamilyLensSelector";
// import axios from "axios";

// import LensPriceDetails from "../components/LensPriceDetails";

export default {
  name: "PricesHome",
  components: {
    PriceCalcTab,
    PriceSettingsHome,
    ProductImage,
  },
  mixins: [
    FiltersMixin,
    //  HardLinksMixin
  ],
  data: () => ({
    // brand_od: null,
    // brand_os: null,
    feesDiscounts: {
      insurance: 0,
      yearDiscount: 0,
      shippingPartial: 0,
      shippingYear: 0,
      willShip: true,
    },
    defaultFeeDiscounts: {},
    lensIDs: null, // if setting lens brands from the URL (may be a single id or an array)
    selectedTab: "tab-0",
    tabCount: 0,
    tabs: [{ title: "Tab 1", image: null, tCount: 0 }],
    maxTabs: 4,
  }),

  computed: {
    noMoreTabs: function () {
      return this.tabs.length >= this.maxTabs;
    },
    medScreen: function () {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    topInputClass: function () {
      return this.medScreen ? "inputSmall" : "inputFull";
    },
    formDirty: function () {
      return this.tabs[0].title || this.tabs.length > 1;
    },
    appendedText: function () {
      return this.feesDiscounts.appendTextToPrinted
        ? this.feesDiscounts.appendTextToPrinted
        : "Please call with any questions";
    },
  },

  methods: {
    // lensImageForFile,
    addTab() {
      this.lensIDs = null;
      this.tabCount++;
      let newTabIndex = this.tabs.length;
      let title = "Tab " + this.tabCount;
      this.tabs.push({ title: title, image: null, tCount: this.tabCount });
      this.$nextTick(() => {
        this.selectedTab = "tab-" + newTabIndex;
      });
    },
    removeTab(index) {
      this.lensIDs = null;
      this.tabs.splice(index, 1);
      //if (!this.tabs.length) this.addTab();
      if (!this.tabs.length) {
        this.tabCount = 0;
        this.addTab();
      }
    },
    resetAllTabs() {
      // let lastIndex = this.tabCount-1;
      // this.addTab();

      if (confirm("Do you really want to start over?")) {
        // for (let i = 0; i < this.tabCount; i++) {
        //   this.removeTab(i);
        // }
        this.$router.push({ path: "/cl_prices/calculator" });
      }
      // this.tabs = [];
      // this.tabCount = 0;
      // this.tabs.push({ title: "Tab 1", image: null, tCount: 0 });
      // this.$refs["tab-0"].resetClicked();
    },
    brandDataChange(index, brandData) {
      this.tabs[index].title = brandData.title;
      this.tabs[index].image = brandData.image;
    },
    printWindow: function () {
      window.print();
    },
    getNumber(val) {
      if (!val) return "0.00";
      return parseFloat(val).toFixed(2);
    },
    fistLenses(index) {
      let rtn = null;
      if (index == 0 && this.lensIDs) {
        rtn = this.lensIDs;
        if (!Array.isArray(rtn) && rtn > 0) rtn = [rtn, rtn];
      }
      return rtn;
    },
    settingsFromDefault(defaults) {
      this.feesDiscounts = { ...this.feesDiscounts, ...defaults };
    },
  },
  watch: {},
  mounted() {
    //console.log()
    this.lensIDs = this.$route.query.lensIDs;
    // console.log(lensIDs);
    // console.log(lensIDs[0]);
  },
};
</script>

<style>
/* .pane {
  padding: 1em;
  margin-top: 1em;
}
.minHeightOnMed {
  min-height: 350px;
}
.sidePane {
  width: 350px;
}
.middlePane {
  width: 350px;
} */
/*
.fullWidth {
  max-width: 90%;
  width: 1150px;
} */

.greenBkg {
  background-color: #ecffed;
}

.blueBkg {
  background-color: #e0f1ff;
}
.smallNum {
  max-width: 50px;
}
.medNum {
  max-width: 90px;
}
.inputSmall {
  max-width: 175px;
}
.inputFull {
  width: 90%;
}
/* .imageIcon {
  max-height: 28px;
  max-width: 50px;
} */
.min200 {
  min-width: 200px;
}

.min140 {
  min-width: 200px;
}
.grayBkgd {
  background-color: transparent !important;
}
.pricesToolbar {
  min-width: 95%;
  /* max-width: 1600px;  */
}
</style>
